/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VenueTypeEnum } from './VenueTypeEnum';
import {
    VenueTypeEnumFromJSON,
    VenueTypeEnumFromJSONTyped,
    VenueTypeEnumToJSON,
    VenueTypeEnumToJSONTyped,
} from './VenueTypeEnum';

/**
 * Lightweight serializer for venue list views.
 * @export
 * @interface VenueList
 */
export interface VenueList {
    /**
     * 
     * @type {string}
     * @memberof VenueList
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof VenueList
     */
    team: number;
    /**
     * 
     * @type {string}
     * @memberof VenueList
     */
    readonly teamName: string;
    /**
     * 
     * @type {string}
     * @memberof VenueList
     */
    name: string;
    /**
     * 
     * @type {VenueTypeEnum}
     * @memberof VenueList
     */
    venueType?: VenueTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VenueList
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VenueList
     */
    readonly stagesCount: string;
    /**
     * 
     * @type {Date}
     * @memberof VenueList
     */
    readonly createdAt: Date;
}



/**
 * Check if a given object implements the VenueList interface.
 */
export function instanceOfVenueList(value: object): value is VenueList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('stagesCount' in value) || value['stagesCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function VenueListFromJSON(json: any): VenueList {
    return VenueListFromJSONTyped(json, false);
}

export function VenueListFromJSONTyped(json: any, ignoreDiscriminator: boolean): VenueList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'team': json['team'],
        'teamName': json['team_name'],
        'name': json['name'],
        'venueType': json['venue_type'] == null ? undefined : VenueTypeEnumFromJSON(json['venue_type']),
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'stagesCount': json['stages_count'],
        'createdAt': (new Date(json['created_at'])),
    };
}

  export function VenueListToJSON(json: any): VenueList {
      return VenueListToJSONTyped(json, false);
  }

  export function VenueListToJSONTyped(value?: Omit<VenueList, 'id'|'team_name'|'stages_count'|'created_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': value['team'],
        'name': value['name'],
        'venue_type': VenueTypeEnumToJSON(value['venueType']),
        'is_active': value['isActive'],
    };
}

